import DoctorViewPage from "./DoctorViewPage";

export default DoctorViewPage;
